import axiosClient from "../axios-client";
import {toastMessage} from "../toaster/toaster";

export const getWhatsAppTemplateList = async () => {
    return axiosClient
        .get("/send/whatsapp-templates")
        .then((res) => {
            return res?.data;
        })
        .catch((error) => {
            toastMessage("Templates not found", "error");
            return error;
        });
};

export const getIndividualWhatsAppTemplateData = async (id) => {
    return axiosClient
        .get(`/send/whatsapp-template/${id}`)
        .then((res) => {
            return res?.data;
        })
        .catch((error) => {
            toastMessage("Template not found", "error");
            return error;
        });
};


export const sendWhatsAppNotification = async (data) => {
    return axiosClient
        .post(`/send/send-bulk-whatsapp`, data)
        .then((res) => {
            toastMessage("Whatsapp notification sent successfully!", "success");
        })
        .catch((error) => {
            toastMessage("Whatsapp notification not sent", "error");
            return error;
        });
};
